import React from 'react';
import PropTypes from 'prop-types';
import { LocalizationContext } from '../../../hoc/Localization';
import { SettingsContext } from '../../../hoc/Settings';
import Button from '../../Button';
import Router from '../../../routes';
import styles from '../Header/styles.less';

const RegisterButton = ({
  course,
  schedules,
  setRegister,
  selectedSchedule,
  setSelectedSchedule,
  canRegister,
  join,
  lastRequestId,
  reference,
  payment,
}) => {
  const { t, locale } = React.useContext(LocalizationContext);
  const {
    domainSettings: { domain },
  } = React.useContext(SettingsContext);

  const [showRegister, setShowRegister] = React.useState(false);

  const {
    trainingType,
    requestUrl,
    self_learning: selfLearning,
    redirect_uri_book: redirectUriBook,
  } = course;

  const courseEndDate = Date.parse(`${course.end_date}`);
  const dateNow = Date.now();

  React.useEffect(() => {
    if (courseEndDate && courseEndDate < dateNow) {
      setShowRegister(false);
    } else {
      setShowRegister(true);
    }
  }, []);

  const handleRegisterClick = () => {
    if (!requestUrl && !join) {
      setRegister(true);
      if (schedules.length) {
        if (!selectedSchedule && schedules) {
          setSelectedSchedule(schedules[0]);
        }
      } else {
        setRegister(true);
      }
    }
  };

  const buttonText = join ? t('join.button.text') : t('frontpage.step.title.4');
  const ext = domain && domain.slice(domain.lastIndexOf('.'));
  const link = `https://app.course${ext}/student/course/train`;

  let buttonContent = buttonText;
  if (requestUrl) {
    buttonContent = (
      <a target="blank" href={`${requestUrl}`}>
        {buttonText}
      </a>
    );
  }
  if (join) {
    const target =
      redirectUriBook && trainingType && trainingType.title === 'ELearning' && !selfLearning
        ? redirectUriBook
        : `${link}/${lastRequestId}`;
    buttonContent = (
      <a target="_blank" rel="noopener noreferrer" href={target}>
        {buttonText}
      </a>
    );
  }

  return (
    <div
      onClick={() => {
        const params = {
          locale,
          course: course.link,
          school: course.school.link,
          id: course.shortId,
        };
        if (reference) {
          params.queryParams = { reference };
        }
        if (payment) {
          params.queryParams = { ...params.queryParams, payment };
        }
        if (!join) {
          params.register = 'register';
        }
        return Router.pushRoute('courseShow', params);
      }}
    >
      <Button
        version="large"
        type="primary"
        id="register"
        disabled={!showRegister || !canRegister}
        onClick={() => handleRegisterClick()}
        className={styles.register}
      >
        {buttonContent}
      </Button>
    </div>
  );
};

RegisterButton.propTypes = {
  course: PropTypes.object,
  schedules: PropTypes.array,
  setRegister: PropTypes.func,
  selectedSchedule: PropTypes.object,
  setSelectedSchedule: PropTypes.func,
  canRegister: PropTypes.bool.isRequired,
  join: PropTypes.bool.isRequired,
  lastRequestId: PropTypes.string,
  reference: PropTypes.string,
};

RegisterButton.defaultProps = {
  course: {},
  schedules: [],
  setRegister: () => { },
  selectedSchedule: null,
  setSelectedSchedule: () => { },
  lastRequestId: '',
  reference: '',
};

export default React.memo(RegisterButton);
